// extracted by mini-css-extract-plugin
module.exports = {"xs":"600","s":"960","sm":"1200","m":"1440","ml":"1600","l":"1920","xl":"2560","mainScope":"NavigationLayout_mainScope__i6Jjn","main":"NavigationLayout_main__91ci_"};